import api from 'api';
import { useEffect, useState } from 'react';
import styles from '../../assessmentPage/Questionnaire/GeneralInfo.module.scss';
import cn from 'classnames';

export interface Data {
    account_holder: string;
    account_holder_address: string;
    account_holder_city: string;
    account_holder_country: string;
    account_holder_post_code: string;
    bank_name: string;
    bank_address: string;
    bank_city: string;
    bank_country: string;
    bank_post_code: string;
    account_number: string;
    swift: string;
    iban: string;
}

export const initBankAccount: Data = {
    account_holder: '',
    account_holder_address: '',
    account_holder_city: '',
    account_holder_country: '',
    account_holder_post_code: '',
    bank_name: '',
    bank_address: '',
    bank_city: '',
    bank_country: '',
    bank_post_code: '',
    account_number: '',
    swift: '',
    iban: '',
};
export default function BankAccountDetailsInfo() {
    const tableName = 'BankAccount';
    const [data, setData] = useState<Data>(initBankAccount);

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(setData, tableName);
    }, []);

    return (
        <>
            <div>
                <span>
                    <h4 className={styles.title}>Account Holder Information</h4>
                    <div className={`grid grid-cols-2 gap-x-5 ${cn(styles.box, styles.fullWidth)}`}>
                        <h4>Name</h4>
                        <h4> Address</h4>
                        <p className={styles.value}>{data?.account_holder}</p>
                        <p className={styles.value}> {data?.account_holder_address}</p>
                        <h4>City</h4>
                        <h4>Postal Code</h4>
                        <p className={styles.value}>{data?.account_holder_city}</p>
                        <p className={styles.value}> {data?.account_holder_post_code}</p>
                        <h4>Country</h4>
                        <h4 aria-hidden="true"></h4>
                        <p className={styles.value}>{data?.account_holder_country}</p>
                    </div>
                </span>
                <span>
                    <h4 className={styles.title}>Bank Information</h4>
                    <div className={`grid grid-cols-2 gap-x-5 ${cn(styles.box, styles.fullWidth)}`}>
                        <h4>Name</h4>
                        <h4>Address</h4>
                        <p className={styles.value}>{data?.bank_name}</p>
                        <p className={styles.value}> {data?.bank_address}</p>
                        <h4>City</h4>
                        <h4>Postal Code</h4>
                        <p className={styles.value}>{data?.bank_city}</p>
                        <p className={styles.value}> {data?.bank_post_code}</p>
                        <h4>Country</h4>
                        <h4 aria-hidden="true"></h4>
                        <p className={styles.value}>{data?.bank_country}</p>
                    </div>
                </span>
                <span>
                    <h4 className={styles.title}>Account Information</h4>
                    <div className={`grid grid-cols-2 gap-x-5 ${cn(styles.box, styles.fullWidth)}`}>
                        <h4>Number</h4>
                        <h4>Swift</h4>
                        <p className={styles.value}>{data?.account_number}</p>
                        <p className={styles.value}> {data?.swift}</p>
                        <h4>Iban</h4>
                        <h4 aria-hidden="true"></h4>
                        <p className={styles.value}>{data?.iban}</p>
                    </div>
                </span>
            </div>
        </>
    );
}
